import { Question } from "./Question";

export interface Category {
  _id?: string;
  title?: string;
  imageFile?: File;
  imageUrl?: string;
  schoolTypes?: Array<SchoolType>;
  createdAt?: Date;
}

export enum SchoolType {
  PRIMARY = "PrimarySchool",
  MIDDLE_AND_HIGH_SCHOOL = "MiddleAndHighSchool",
}

export interface FilteringCategory {
  _id?: string;
  title?: string;
  isSelected?: boolean;
  questions?: Array<Question>;
}
